import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CapNotificationService {

  public errorActivatedSource = new Subject<any>();
  public startIimeoutActivatedSource = new Subject<any>();

  //Subscribe
  public errorActivated$ = this.errorActivatedSource.asObservable();
  public startTimeoutActivated$ = this.startIimeoutActivatedSource.asObservable();

  public broadcastErrorActivated(activated: any) {
    this.errorActivatedSource.next(activated);
  }

  public broadcastStartTimeoutActivated(activated: any) {
    this.startIimeoutActivatedSource.next(activated);
  }

}
